var map = {
	"./ods1.jpg": 1646,
	"./ods10.jpg": 324,
	"./ods11.jpg": 8369,
	"./ods12.jpg": 2438,
	"./ods13.jpg": 5603,
	"./ods14.jpg": 4672,
	"./ods15.jpg": 253,
	"./ods16.jpg": 354,
	"./ods17.jpg": 8287,
	"./ods2.jpg": 5353,
	"./ods3.jpg": 9980,
	"./ods4.jpg": 7975,
	"./ods5.jpg": 3514,
	"./ods6.jpg": 6117,
	"./ods7.jpg": 3752,
	"./ods8.jpg": 8243,
	"./ods9.jpg": 5078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 856;